import { Tooltip, TooltipProps } from '@chakra-ui/react';
import React from 'react';

// Use React.forwardRef to properly handle refs passed to the component
export const HabityTooltip = React.forwardRef<HTMLDivElement, TooltipProps>(
  (props, ref) => (
    <Tooltip
      hasArrow
      fontSize={props.fontSize || 'xs'}
      maxWidth={props.maxW || 200}
      placement="bottom"
      rounded="lg"
      p="2"
      backgroundColor="black"
      color="white"
      textAlign="center"
      // openDelay={400}
      {...props}
      ref={ref}
    >
      {props.children}
    </Tooltip>
  )
);
